import { Table } from "antd";
import React, { useEffect, useState } from "react";
import { useQuery, useQueryClient } from "react-query";
import { useSelector } from "react-redux";
import { showNotificationWithIcon } from "../../../utils/helpers/helpers";
import { getList, getOne } from "../../../utils/http/dataProvider";
import { getUserInfo } from "../../../utils/redux/reducers/User";

import "./QrcodeDetailList.scss";
import { qrcodeDetailListColumns } from "./qrcodeDetailListColumns";
import QrcodeDetailListHeader from "./QrcodeDetailListHeader";
import TransferToVipModal from "./TransferToVipModal";
import { useHistory, useLocation } from "react-router-dom";
import { getMerchantSettings } from "../../../utils/redux/reducers/Merchant";

const TYPE_ALL = -1;
const TYPE_BOX = 2;
const TYPE_PRODUCT = 3;
const OWNERSHIP_ALL = -1;
const OWNERSHIP_OWNED = 1;
const OWNERSHIP_UNASSIGNED = 0;

const QrcodeDetailList = () => {
  const user = useSelector((state) => getUserInfo(state));
  const settings = useSelector((state) => getMerchantSettings(state));
  const queryClient = useQueryClient();
  const [keyword, setKeyword] = useState();
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [typeFilter, setTypeFilter] = useState(TYPE_ALL);
  const [ownershipFilter, setOwnershipFilter] = useState(OWNERSHIP_ALL);
  const [transferModalItem, setTransferModalItem] = useState(null);

  const location = useLocation();
  const history = useHistory();
  const qrcodeId = location?.query?.id;

  const { data: qrcode } = useQuery(
    ["lottery-qrcode", qrcodeId, user.token],
    () =>
      getOne("lottery-qrcode", {
        id: qrcodeId,
        token: user.token,
      }),
    { enabled: !!qrcodeId }
  );

  useEffect(() => {
    if (qrcode != null) {
      const hasBox = (qrcode.box_capacity ?? 0) > 0;
      setTypeFilter(hasBox ? TYPE_BOX : TYPE_ALL);
    }
  }, [qrcode?.id, qrcode?.box_capacity]);



  const { data, error, isLoading } = useQuery(
    ["lottery-qrcode-list", user.token, qrcodeId, page, keyword, typeFilter, ownershipFilter],
    () => {
      const queryFilter = { keyword };
      if (typeFilter !== TYPE_ALL) queryFilter.type = typeFilter;
      if (ownershipFilter !== OWNERSHIP_ALL) queryFilter.owned = ownershipFilter;
      return getList(`lottery-qrcode/${qrcodeId}/qrcode-list`, {
        pagination: {
          perPage: 10,
          page,
        },
        sort: {
          field: "id",
          order: "desc",
        },
        filter: queryFilter,
        token: user.token,
      })
    },
    { enabled: !!qrcodeId }
  );

  const handleChangePage = (newPage) => {
    setPage(newPage);
  };

  if (!qrcodeId) {
    history.goBack();
    return null;
  }

  if (error) {
    showNotificationWithIcon(error.data?.message ?? error.message);
  }

  const handleTransferSuccess = () => {
    queryClient.invalidateQueries(["lottery-qrcode-list", user.token, qrcodeId]);
  };

  return (
    <div className="qrcode-list">
      <QrcodeDetailListHeader
        keyword={keyword}
        setKeyword={setKeyword}
        typeFilter={typeFilter}
        setTypeFilter={setTypeFilter}
        ownershipFilter={ownershipFilter}
        setOwnershipFilter={setOwnershipFilter}
      />
      <Table
        className="list"
        loading={isLoading || loading}
        rowKey="id"
        columns={qrcodeDetailListColumns(
          user.token,
          setLoading,
          history,
          settings.enable_lottery_qrcode_transfer ? (record) => setTransferModalItem(record) : null
        )}
        dataSource={data?.data}
        scroll={{
          y: 640,
          x: 1200,
        }}
        pagination={{
          onChange: handleChangePage,
          showQuickJumper: true,
          total: data?.total,
        }}
      />
      <TransferToVipModal
        visible={!!transferModalItem}
        item={transferModalItem}
        onCancel={() => setTransferModalItem(null)}
        onSuccess={handleTransferSuccess}
      />
    </div>
  );
};

export default QrcodeDetailList;
